import {
  ROLE_SALON_ADMIN,
  ROLE_SYSTEM_ADMIN,
  ROLE_FRONT_DESK,
  ROLE_JDTECH_ADMIN,
} from "./constants";

/** Admin, Salon Admin, and Front Desk can view/edit appointment payment method. */
export const PAYMENT_METHOD_MANAGEMENT_ROLES = [
  ROLE_SALON_ADMIN,
  ROLE_SYSTEM_ADMIN,
  ROLE_FRONT_DESK,
  ROLE_JDTECH_ADMIN,
];

export function canManagePaymentMethod(userRoles) {
  return (
    userRoles?.some((role) =>
      PAYMENT_METHOD_MANAGEMENT_ROLES.includes(role)
    ) ?? false
  );
}
